import { render, staticRenderFns } from "./faceDetect.vue?vue&type=template&id=10e84cdf&scoped=true&"
import script from "./faceDetect.vue?vue&type=script&lang=js&"
export * from "./faceDetect.vue?vue&type=script&lang=js&"
import style0 from "./faceDetect.vue?vue&type=style&index=0&id=10e84cdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e84cdf",
  null
  
)

export default component.exports